// extracted by mini-css-extract-plugin
export default {"about_donor":"AboutDonor_about_donor__4j5D8","ad_content":"AboutDonor_ad_content__yb9pQ"};